import { useParams } from "react-router-dom";
import { RollupDashboard } from "../../components/RollupDashboard";

export function DistrictDashboard() {
  const { id } = useParams();
  return (
    <RollupDashboard
      scopeType="district"
      scopeId={Number(id)}
      title={`District #${id}`}
      subtitle="All godowns in this district."
    />
  );
}
